import { createSelector } from "@reduxjs/toolkit"
import { AppRootState } from "./appStore"

export const selectDashboardListLoading = createSelector(
	(state: AppRootState) => state.app.ldng,
	(ldng): boolean => {
		return Boolean(
			ldng.apiAudit ||
			ldng.apiDevDestroyEncounters ||
			ldng.syncCloudToDevice
		)
	}
)

export const selectOpIsBlockingEncounterMgmt = createSelector(
	selectDashboardListLoading,
	(state: AppRootState) => (state.sync.startedAt !== null && state.sync.endedAt === null),
	(ldng, syncing): boolean => {
		return ldng || syncing
	}
)
